import { darken } from 'polished';
import { css, styled } from 'styled-components';

import { ContainerAvatarType } from './types';

export const ContainerAvatar = styled.div<ContainerAvatarType>`
  .chakra-avatar {
    background-color: ${({ theme }) => darken(0.1, theme.colors.light.color)};
    border: 1px solid ${({ theme }) => theme.colors.white};
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);

    ${({ size }) =>
      size === 'lg' &&
      css`
        width: 4.813rem;
        height: 4.813rem;
        border: 3px solid ${({ theme }) => theme.colors.white};
      `}

    .chakra-avatar__badge {
      width: 1.25rem;
      height: 1.25rem;
      border: 1px solid ${({ theme }) => theme.colors.white};
      background-color: ${({ background }) => background};
      box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);
      top: -0.4rem;

      ${({ position }) =>
        position === 'left' &&
        css`
          left: -0.7rem;
        `}

      ${({ position }) =>
        position === 'right' &&
        css`
          right: 0rem;
        `}

        ${({ hideBadge }) =>
        hideBadge &&
        css`
          display: none;
        `}

      svg {
        width: 0.75rem;
        color: ${({ theme }) => theme.colors.white};
      }

      ${({ size, position }) =>
        size === 'lg' &&
        css`
          width: 2.7rem;
          height: 2.7rem;
          border: 3px solid ${({ theme }) => theme.colors.white};
          top: -1rem;

          svg {
            width: 1.1rem;
          }

          ${
            position === 'right' &&
            css`
              right: -0.7rem;
            `
          }
          
          ${
            position === 'left' &&
            css`
              left: -2.1rem;
            `
          }
        }
        `}
    }
  }
`;
